<div class="project-header-component flex-row space-between">
  <div class="flex-row gap-10">
    <img
      src="assets/inwedio_white.svg"
      alt=""
      style="height: 16px; position: relative; top: -3px"
      (click)="$event.stopPropagation(); exit()"
      class="cursor-pointer"
    />
    <div class="fs-12">{{ projectLabel$ | async }}</div>
  </div>

  <div class="flex-row fs-13 gap-8">
    <!-- 
      <div class="flex-row gap-6" *ngIf="cs.previewShape">
        <div>{{ cs.previewShape.translateX?.toFixed() }}</div>
        <div>{{ cs.previewShape.translateY?.toFixed() }}</div>
      </div>
      <div style="width: 1px; height: 14px; background-color: black"></div>
      <div>{{ (cs.canvasScale * 100).toFixed() }}%</div> 
      <nw-icon
        type="forum"
        [outlined]="true"
        [color]="'white'"
        [size]="18"
        matTooltip="Start AI assistance"
        (click)="startAIAssistance($event)"
      ></nw-icon>
    -->
  </div>

  <div class="flex-row gap-10">
    <nw-icon
      type="download"
      [outlined]="true"
      [color]="'white'"
      [size]="18"
      matTooltip="Export"
      (click)="$event.stopPropagation(); startExport()"
    ></nw-icon>
    <!-- <nw-icon
      type="language"
      [outlined]="true"
      [color]="'white'"
      [size]="18"
    ></nw-icon> -->
    <nw-icon
      type="palette"
      [outlined]="true"
      [color]="'white'"
      [size]="18"
      (click)="$event.stopPropagation(); showColorPalette()"
    ></nw-icon>
    <nw-icon
      type="group"
      [outlined]="true"
      [color]="'white'"
      [size]="18"
    ></nw-icon>
  </div>

  <!-- <div class="main-header editor-container flex-row space-between w-100 fs-14">
    <nw-icon type="arrow_back" (click)="exit()"></nw-icon>
    <nw-icon type="settings" [outlined]="true"></nw-icon>
  </div>

  <div *ngIf="editOpen" class="project-settings editor-container">
    <div class="inner-container flex-column start gap-10">
      <div class="flex-row gap-8 pointer" (click)="selectOverlay('languages')">
        <nw-icon type="language" [size]="13"></nw-icon>
        <div class="fs-13">Languages</div>
      </div>
      <div
        class="flex-row gap-8 pointer"
        (click)="selectOverlay('color-palette')"
      >
        <nw-icon type="palette" [size]="13" [outlined]="true"></nw-icon>
        <div class="fs-13">Color Palette</div>
      </div>
      <div class="flex-row gap-8 pointer">
        <nw-icon type="group" [size]="13" [outlined]="true"></nw-icon>
        <div class="fs-13">Users</div>
      </div>
      <div class="flex-row gap-8 pointer" (click)="exit()">
        <nw-icon type="arrow_back" [size]="14" [outlined]="true"></nw-icon>
        <div class="fs-13">Exit</div>
      </div>
    </div>
    <div class="close-container" (click)="editOpen = false">
      <nw-icon type="keyboard_arrow_up" [size]="20" [outlined]="true"></nw-icon>
    </div>
  </div> -->
</div>
